import React, { useEffect } from "react";
import { ApolloProvider } from "@apollo/client";
import Router from "./Router";
import { mainClient, initializeWebSocket } from "./apollo";

import "./index.css";
import "./styles/bento-grid.css";
import AntiSleepSystem from "./utils/antiSleepSystem";
import authService from "./services/authService";
import { Toaster } from "./components/ui/sonner";

function App() {
  useEffect(() => {
    // 슬립모드 방지 시스템 자동 시작
    const antiSleep = new AntiSleepSystem();

    // 개발 환경에서 로그 확인
    if (process.env.NODE_ENV === 'development') {
      window.antiSleep = antiSleep;
    }

    // 새로고침 시 이미 로그인된 상태라면 WebSocket 자동 초기화
    if (authService.isAuthenticated()) {
      console.log("🔄 로그인 상태 감지 - WebSocket 자동 초기화");
      initializeWebSocket();
    }

    return () => {
      // 정리 작업 (필요시)
    };
  }, []);

  return (
    <div className="App">
      <ApolloProvider client={mainClient}>
        <Router />
      </ApolloProvider>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
